<template>
  <div class="text-center">
    <v-dialog
      v-model="active"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{message}}
          <v-progress-linear
            indeterminate
            :color="'#FFF'"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  computed: {
    isActive () {
      return this.active
    }
  },
  props: ['active', 'message']
}
</script>



// WEBPACK FOOTER //
// src/components/loading/DialogLoading.vue